export enum OutUnit {
	Unknown = 0,
	Kelvin = 1,
	DegCelsius = 2,
	DegFahrenheit = 3,
	RelHumidity = 4,
}
